import React, { useRef, useState } from "react";

import {
    View,
    Text,
    TouchableOpacity,
    Platform,
    Image,
    ViewStyle,
    ImageStyle,
    ImageResizeMode,
    StyleSheet
} from "react-native";
import AppTheme from "../../../shared/utils/Theme";
import ActivityIndicator from "../../../shared/designSystem/ActivityIndicator/ActivityIndicator";
import CloseButton from "../../../shared/designSystem/Buttons/CloseButton";
import Images from "../../utils/Images";
import ViewPager from "../ViewPager/ViewPager";
import SVGIconButton from "../../../shared/designSystem/Buttons/SVGIconButton";
import { IcPrint } from "../../../shared/utils/Icons";
import { useReactToPrint } from "react-to-print";

interface ImagesSlideshowProps {
    closeTheGame: () => void,
    color: string,
    slideshowImages: { app: string, db: string }[]
}


const ImagesSlideshow = (props: ImagesSlideshowProps) => {

    const appTheme: AppTheme = new AppTheme();
    const images: Images = new Images();

    const { color, closeTheGame, slideshowImages } = props;

    let currentPage: number = useRef<number>(0).current;
    const contentRef = useRef<HTMLDivElement>(null);
    const reactToPrintFn = useReactToPrint({ contentRef });

    const [viewDidAppear, setViewDidAppear] = useState<boolean>(false);

    const onViewDidAppear = () => {
        setViewDidAppear(true);
    }

    const onCloseRequest = () => {
        closeTheGame();
    }


    const onPrintRequest = () => {
        console.log({currentPage});
        const imageToPrint = slideshowImages[currentPage].db;
        const printWindow = window.open('', '_blank');
        printWindow.document.write(`
      <html>
        <head>
          <title>Impression de l'image</title>
          <style>
            body {
              margin: 0;
              text-align: center;
            }
            img {
              max-width: 100%;
              height: auto;
            }
          </style>
        </head>
        <body>
          <img src="${imageToPrint}" onload="window.print(); window.onafterprint = window.close;" />
        </body>
      </html>
    `);
        printWindow.document.close();
    }

    const mainContainer: ViewStyle = {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        transform: [
            {
                rotate: Platform.OS === "web" ? "Odeg" : "90deg"
            }
        ]
    }

    const mainView: ViewStyle = {
        width: Platform.OS === "web" ? appTheme.getFullAppWidth() : appTheme.getFullScreenHeight(),
        height: Platform.OS === "web" ? appTheme.getFullAppHeight() : appTheme.getFullScreenWidth(),
        justifyContent: "center",
        alignItems: "center"
    }

    const imageStyle: ImageStyle = {
        width: Platform.OS === "web" ? appTheme.getFullAppWidth() : appTheme.getFullScreenHeight(),
        height: Platform.OS === "web" ? appTheme.getFullAppHeight() : appTheme.getFullScreenWidth()
    }

    const closeButtonView: ViewStyle = {
        position: "absolute",
        top: appTheme.pixelPerfect(10),
        right: appTheme.pixelPerfect(10) + appTheme.bottomInsets
    }

    const printButtonView: ViewStyle = {
        position: "absolute",
        top: appTheme.pixelPerfect(10),
        left: appTheme.pixelPerfect(10) + appTheme.topInsets
    }

    const getContent = () => {
        // Bouton de fermeture
        const closeButton: React.JSX.Element = <View style={closeButtonView}>
            <CloseButton onPress={onCloseRequest} color={color} />
        </View>;
        //Bouton d'impression
        const printButton: React.JSX.Element = <View style={printButtonView}>
            <SVGIconButton Icon={IcPrint} onPress={onPrintRequest} color={color} />
        </View>;
        if (viewDidAppear === false) {
            return <View onLayout={onViewDidAppear} style={mainView}>
                <ActivityIndicator loading={viewDidAppear === false} color={appTheme.white} />
                {closeButton}
            </View>
        }
        const imageResizeMode: ImageResizeMode = Platform.OS === "web" ? "contain" : "cover";
        let imagesView: React.JSX.Element[] = [];
        if (slideshowImages !== undefined) {
            for (const aImageIndex in slideshowImages) {
                if (Object.prototype.hasOwnProperty.call(slideshowImages, aImageIndex)) {
                    const anImageSource: { app: string, db: string } = slideshowImages[aImageIndex];
                    if (anImageSource !== undefined) {
                        const { app, db } = anImageSource;
                        let anImageSourceToDisplay: { uri: string } = { uri: db };
                        if (images[app] !== undefined) {
                            anImageSourceToDisplay = images[app];
                        }
                        imagesView.push({
                            key: "image_" + aImageIndex,
                            view: <Image source={anImageSourceToDisplay} style={imageStyle} resizeMode={imageResizeMode} />
                        });
                    }
                }
            }
        }

        return <View style={mainView}>
            <ViewPager
                onPageSelected={(page) => {
                    console.log({page});
                    currentPage = page;
                }}
                showNavigationButton={true}
                mainColor={color}
                isHorizontal={true}
                views={imagesView}
                pageToShow={0}
                style={imageStyle} />
            {closeButton}
            {printButton}
        </View>
    }

    return <View style={mainContainer}>
        {getContent()}
    </View>

}

export default ImagesSlideshow;